// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Background+Border + chart container — Figma node 4126:19717 (Gestão Dinâmica de Orçamento) */
.gofOpS4ZplZycLCounbw {
  position: relative;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  overflow: hidden;
  min-height: 405px;
  display: flex;
  flex-direction: column;
}

.lImzFEXLBidA1iKQ_Tnw {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.65);
  z-index: 1;
  border-radius: 12px;
}

.lyTFQ7Zx1bbzzBNG_UNw {
  flex: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 20px 0 0;
  width: 100%;
}

.ofEhMLWsj7rDTjpWKQMI {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-sizing: border-box;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/pages/campaigns/spend-reports/elements/ChartBox/styles.module.css"],"names":[],"mappings":"AAAA,+FAA+F;AAC/F;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,WAAW;AACb","sourcesContent":["/* Background+Border + chart container — Figma node 4126:19717 (Gestão Dinâmica de Orçamento) */\n.wrapper {\n  position: relative;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  overflow: hidden;\n  min-height: 405px;\n  display: flex;\n  flex-direction: column;\n}\n\n.overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.65);\n  z-index: 1;\n  border-radius: 12px;\n}\n\n.content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  padding: 20px 0 0;\n  width: 100%;\n}\n\n.loader {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  box-sizing: border-box;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `gofOpS4ZplZycLCounbw`,
	"overlay": `lImzFEXLBidA1iKQ_Tnw`,
	"content": `lyTFQ7Zx1bbzzBNG_UNw`,
	"loader": `ofEhMLWsj7rDTjpWKQMI`
};
export default ___CSS_LOADER_EXPORT___;
